import template from './pdfViewer.html';
import { PdfViewerController } from './pdfViewer.controller';

export const pdfViewerComponent = {
  name: 'pdfViewerJsComponent',
  restrict: 'E',
  template,
  transclude: true,
  controllerAs: 'vm',
  controller: PdfViewerController,
  bindings: {
    src: '<',
    url: '<',
    isBase64: '@',
    redirect: '=',
    overlay: '<',
  },
};
